import { observable } from 'mobx';
import { Advert } from './Advert';
import { AdvertSlot } from '../constants';

export class SiteAdverts {
  @observable public [AdvertSlot.SiteBanner]: Array<Advert>;
  @observable public [AdvertSlot.HomepageBanner]: Array<Advert>;
  @observable public [AdvertSlot.CategoryIndexOne]: Array<Advert>;
  @observable public [AdvertSlot.CategoryIndexTwo]: Array<Advert>;
}

export default SiteAdverts;



// WEBPACK FOOTER //
// ./src/app/models/SiteAdverts.ts